import { Navigate } from "react-router-dom";
import MyUpgradeApplicationsPage from "./pages/MyUpgradeApplicationsPage";
import UpgradeApplicationDetailsPage from "./pages/UpgradeApplicationDetailsPage";
import UpgradeApplicationWizard from "./pages/UpgradeApplicationWizard";
import GradeUpgradeDetailsPage from "./pages/GradeUpgradeDetailsPage";
import AdminUpgradeApplicationsPage from "./pages/AdminUpgradeApplicationsPage";
import AdminCommitteeAssignmentPage from "./pages/AdminCommitteeAssignmentPage";
import AdminUpgradeReviewDietsPage from "./pages/AdminUpgradeReviewDietsPage";
import AdminUpgradeReviewDietDetailsPage from "./pages/AdminUpgradeReviewDietDetailsPage";
import AdminUpgradeCategoryPage from "./pages/AdminUpgradeCategoryPage";
import AdminUpgradeApplicationDetailPage from "./pages/AdminUpgradeApplicationDetailPage";
import UpgradePaymentProcessingPage from "./pages/UpgradePaymentProcessingPage";

const MEMBER_ROLES = [
  "member",
  "fellow",
  "executive",
  "chairman",
  "secretary",
  "assessor",
  "past president",
  "probationer",
  "student",
  "technician",
];

export const upgradeApplicationRoutes = [
  // My applications list — primary landing page
  {
    path: "/upgrade-applications",
    element: <MyUpgradeApplicationsPage />,
    roles: MEMBER_ROLES,
  },
  // Dedicated upgrade wizard: update the probationer-application details
  // through the steps, then pay on the final step.
  {
    path: "/upgrade-applications/grade",
    element: <UpgradeApplicationWizard />,
    roles: MEMBER_ROLES,
  },

  // ── Legacy paths — funnel into the upgrade wizard ────────────────────────
  {
    path: "/upgrade-applications/new",
    element: <Navigate to="/upgrade-applications/grade" replace />,
    roles: MEMBER_ROLES,
  },
  {
    path: "/upgrade-applications/membership/new",
    element: <Navigate to="/upgrade-applications/grade" replace />,
    roles: MEMBER_ROLES,
  },
  {
    path: "/upgrade-applications/fellowship/new",
    element: <Navigate to="/upgrade-applications/grade" replace />,
    roles: MEMBER_ROLES,
  },

  // Firm application now lives in its own module (/firm-applications).
  // Post-payment processing screen (OnePay returns here for upgrade payments)
  {
    path: "/upgrade/payment-processing/:id",
    element: <UpgradePaymentProcessingPage />,
    roles: MEMBER_ROLES,
  },
  // Member's grade-upgrade detail (more specific than :kind/:id below)
  {
    path: "/upgrade-applications/grade/:id",
    element: <GradeUpgradeDetailsPage />,
    roles: MEMBER_ROLES,
  },
  // Per-application detail page — :kind is "membership", "fellowship", or "firm"
  {
    path: "/upgrade-applications/:kind/:id",
    element: <UpgradeApplicationDetailsPage />,
    roles: MEMBER_ROLES,
  },

  // ── Admin: grade upgrade review (category-based) ─────────────────────────
  // The privilege IS the authority here — no role check alongside it, so that
  // granting upgrade_applications.access to an executive office (the president)
  // is all that is needed to open this section, and holding the admin role is
  // not. Previously these listed the admin role AND the permission, which the
  // route guard ANDs together, so a non-admin holder was bounced.
  {
    // Review cycles — the upgrade counterpart of logbook assessment diets.
    // Declared before the /:id route below, which would otherwise swallow
    // "review-cycles" as an application id.
    path: "/admin/upgrade-applications/review-cycles",
    element: <AdminUpgradeReviewDietsPage />,
    perms: ["upgrade_applications.access"],
  },
  {
    path: "/admin/upgrade-applications/review-cycles/:id",
    element: <AdminUpgradeReviewDietDetailsPage />,
    perms: ["upgrade_applications.access"],
  },
  {
    // Membership Committee assignment queue — laid out like the logbook
    // assessment screen. Declared before the :categoryId route below.
    path: "/admin/upgrade-applications/committee",
    element: <AdminCommitteeAssignmentPage />,
    perms: ["upgrade_applications.access"],
  },
  {
    path: "/admin/upgrade-applications",
    element: <AdminUpgradeApplicationsPage />,
    perms: ["upgrade_applications.access"],
  },
  {
    path: "/admin/upgrade-applications/category/:categoryId",
    element: <AdminUpgradeCategoryPage />,
    perms: ["upgrade_applications.access"],
  },
  {
    path: "/admin/upgrade-applications/:id",
    element: <AdminUpgradeApplicationDetailPage />,
    perms: ["upgrade_applications.access"],
  },
];
